






















































































































import Vue from "vue";
import Component from "vue-class-component";
import QNotify from "@/common/qNotify";
import QErrors from "@/common/qErrors.vue";
import { UserManagerService } from "@/common/api/services/UserManagerService";
import { UserManagementGroupDTO } from "@/common/api";
import qNotify from "@/common/qNotify";
import { compareWithKeys } from "@/common/utils";
import { ADMIN_GROUP_ROLE, ADMIN_ROLE } from "@/common/constant";
import { namespace } from "vuex-class";
import QSelect2 from "@/common/qSelect2.vue";

const auth = namespace("Auth");
@Component({
  name: "UserAdd",
  components: {
    QSelect2,
    QErrors,
  },
})
export default class UserAdd extends Vue {
  @auth.Getter
  isAdmin!: boolean;

  @auth.Getter
  getUsingGroup!: string;

  @auth.Getter
  getUsingGroupName;

  public isShow = false;
  public errors = {};
  public errorStyle = {
    maxWidth: "100%",
  };
  public groups: UserManagementGroupDTO[] = null;

  public initForm = {
    userName: "",
    groupId: "",
    groupName: "",
    role: "",
    email: "",
    password: "",
  };

  public form = {
    userName: "",
    groupId: "",
    groupName: "",
    role: "",
    email: "",
    password: "",
  };

  public option = [];
  public select2Config = { width: "100%" };

  mounted() {
    if (this.isAdmin) {
      this.getGroups();
    }

    this.initForm = {
      userName: "",
      groupId: this.isAdmin ? "" : this.getUsingGroup,
      groupName: this.isAdmin ? "" : this.getUsingGroupName,
      role: this.isAdmin ? ADMIN_ROLE : ADMIN_GROUP_ROLE,
      email: "",
      password: "",
    };
    this.clearForm();
  }

  public clearForm() {
    this.form = { ...this.initForm };
  }

  public setGroupName() {
    this.form.groupName = this.groups
      ? this.groups.find((item) => item.id.toString() == this.form.groupId).name
      : "";
  }

  async getGroups() {
    let result;
    try {
      result = await UserManagerService.adminUserGroups({});
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      this.groups = result.data.groups;
      this.groups.map((group: any) => {
        this.option.push({
          id: group.id,
          text: group.name,
        });
        return group;
      });
    } else {
      QNotify.error({
        text: result.body.message,
      });
    }
  }

  public show() {
    this.clearForm();
    this.errors = {};
    this.isShow = true;
  }

  async addUser() {
    this.errors = {};
    let result;
    try {
      if (this.form.role == ADMIN_GROUP_ROLE) {
        this.form.password = "";
      }
      result = await UserManagerService.adminUserCreate(this.form);
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      qNotify.success({
        text: this.$t("common.message.created"),
      });
      this.isShow = false;
      this.$emit("close");
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      QNotify.error({
        text: result.body.message,
      });
    }
  }

  public cancel() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: `${this.$t("common.modal.cancel_content")}`,
        confirmText: `${this.$t("common.buttons.yes")}`,
        cancelText: `${this.$t("common.buttons.no")}`,
        onConfirm: () => {
          this.isShow = false;
        },
      });
    } else {
      this.isShow = false;
    }
  }

  public isChanged() {
    return !compareWithKeys(this.form, this.initForm, [
      "userName",
      "groupId",
      "role",
      "email",
      "password",
    ]);
  }

  public changeRole() {
    this.form.groupId = "";
    this.form.groupName = "";
  }
}
